<template>
  <v-container>
    <PageHeader no-padding />
    <Subheader v-model="search" title="Ecosurvey EDD File Ingestion Schemas" search="ecosurvey EDD file ingestion schemas">
      <!-- <v-dialog v-model="addFormDialog" width="500" persistent>
        <template v-slot:activator="{ on }">
          <v-btn dark color="add" v-on="on">
            <v-icon class="mr-1">add</v-icon>
            {{ $t('DatasetMetadataSchemaManage.addTitleMsg') }}
          </v-btn>
        </template>
        <DatasetMetadataSchemaAddForm @close="addFormDialog=false" />
      </v-dialog> -->
    </Subheader>

    <v-card>
      <v-card-text>
        <v-data-table :loading="isLoading" :headers="headers" :pagination.sync="pagination" :items="schemas" :search="search">
          <template v-slot:items="props">
            <td>{{ props.item.SurveyProgramName }}</td>
            <td>{{ props.item.SurveyType }}</td>
            <td class="text-xs-right">
              <v-btn small color="warning" @click="viewSchema(props.item)">
                <v-icon class="mr-1">edit</v-icon>
                {{ $t('Button.View') }}
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <ErrorDialog v-model="errorDialog.show" :data="errorDialog.data" :title="errorDialog.title"></ErrorDialog>
    <app-modal v-model="dialog" max-width="800">
      <template v-slot:title>Ecosurvey ingestion schema for {{ selectedSchema.SurveyProgramName }} program {{selectedSchema.SurveyType}} survey type</template>
      <template v-slot:text>
        <v-layout row wrap fill-height class="tile-layout">
          <v-flex xs12 md6 pa-1>
            <v-text-field box label="Survey Program Name" disabled hide-details v-model="selectedSchema.SurveyProgramName">
            </v-text-field>
          </v-flex>
          <v-flex xs12 md6 pa-1>
            <v-text-field box label="Survey Type" disabled hide-details v-model="selectedSchema.SurveyType">
            </v-text-field>            
          </v-flex>
        </v-layout>        
         
        <EcosurveyIngestionSchemaColumn v-bind:columnName="`Date Column`" v-bind:columnData="selectedSchema.DateColumn"></EcosurveyIngestionSchemaColumn>
        <EcosurveyIngestionSchemaColumn v-bind:columnName="`Time Start Column`" v-bind:columnData="selectedSchema.TimeStartColumn"></EcosurveyIngestionSchemaColumn>
        <EcosurveyIngestionSchemaColumn v-bind:columnName="`Time End Column`" v-bind:columnData="selectedSchema.TimeEndColumn"></EcosurveyIngestionSchemaColumn>
        <EcosurveyIngestionSchemaColumn v-bind:columnName="`UTC Offset Column`" v-bind:columnData="selectedSchema.UTCOffsetColumn"></EcosurveyIngestionSchemaColumn>
        <EcosurveyIngestionSchemaColumn v-bind:columnName="`Survey Location Column`" v-bind:columnData="selectedSchema.SurveyLocationColumn"></EcosurveyIngestionSchemaColumn>
        <EcosurveyIngestionSchemaColumn v-bind:columnName="`Specimen Name Column`" v-bind:columnData="selectedSchema.SpecimenNameColumn"></EcosurveyIngestionSchemaColumn>

        <v-layout v-for="optionColumn in selectedSchema.LocationMetadataColumns"
                  v-bind:key="optionColumn.Header">
        <EcosurveyIngestionSchemaColumn v-bind:columnData="optionColumn"></EcosurveyIngestionSchemaColumn>
        </v-layout>

        <v-layout v-for="optionColumn in selectedSchema.SpecimenTaxonomyColumns"
                  v-bind:key="optionColumn.Header">
        <EcosurveyIngestionSchemaColumn v-bind:columnData="optionColumn"></EcosurveyIngestionSchemaColumn>
        </v-layout>

        <v-layout v-for="optionColumn in selectedSchema.SpecimenMetadataColumns"
                  v-bind:key="optionColumn.Header">
        <EcosurveyIngestionSchemaColumn v-bind:columnData="optionColumn"></EcosurveyIngestionSchemaColumn>
        </v-layout>

        <v-layout v-for="optionColumn in selectedSchema.SpecimenVariableDataColumns"
                  v-bind:key="optionColumn.Header">
        <EcosurveyIngestionSchemaColumn v-bind:columnData="optionColumn"></EcosurveyIngestionSchemaColumn>
        </v-layout>

        <v-layout v-for="optionColumn in selectedSchema.SpecimenVariableDataUnitColumns"
                  v-bind:key="optionColumn.Header">
        <EcosurveyIngestionSchemaColumn v-bind:columnData="optionColumn"></EcosurveyIngestionSchemaColumn>
        </v-layout>
      </template>
      <template v-slot:actions>
        <v-spacer></v-spacer>     
        <v-btn color="secondary" @click="dialog = false" outline>Close</v-btn>
      </template>
    </app-modal>
  </v-container>
</template>

<script>
  import ErrorDialog from '@/components/generic/ErrorDialog'
  import DatasetMetadataSchemaAddForm from './DatasetMetadataSchemaAddForm'
  import AppModal from '@/components/generic/AppModal'
  import EcosurveyIngestionSchemaColumn from '@/components/DataSets/EcosurveyIngestionSchemaColumn'

  import {
    createNamespacedHelpers,
  } from 'vuex'
  const app = createNamespacedHelpers('app')
  const rawdatarepository = createNamespacedHelpers('rawdatarepository')
  const serviceconfigurations = createNamespacedHelpers('serviceconfigurations')
  const authenticate = createNamespacedHelpers('authenticate')

  export default {
    components: {
      'app-modal': AppModal,
      DatasetMetadataSchemaAddForm,
      ErrorDialog,
      EcosurveyIngestionSchemaColumn,
    },
    data() {
      return {
        search: '',
        selectedSchema: {},
        dialog: false,
        isLoading: false,
        pagination: {
          rowsPerPage: -1,
        },
        headers: [{
          text: 'Survey Program',
          align: 'left',
          value: 'SurveyProgramName',
        },
        {
          text: 'Survey Type',
          align: 'left',
          value: 'SurveyType',
        },
        {
          align: 'left',
          value: null,
          sortable: false,
        },
        ],
        addFormDialog: false,
        schemas: [],
      }
    },
    computed: {
      ...rawdatarepository.mapGetters(['metadataSchemas']),
      ...authenticate.mapGetters(['currentTenant']),
      metadataSchemaData() {
        return this.metadataSchemas.data
      },
      errorDialog() {
        return this.$store.getters['app/errorDialog']
      },
    },
    methods: {
      ...app.mapActions(['setSnackbar']),
      ...rawdatarepository.mapActions(['getMetadataSchemas', 'addSchema']),
      ...serviceconfigurations.mapActions(['fetchTenantConfigurations']),
      fetchMetadataSchemas({
        forced,
      }) {
        let options = {
          successCb: () => null,
          failedCb: (err) => {
            console.error('failed getting metadata schemas ', err),
              this.$store.dispatch('app/setErrorDialog', {
                data: err.response.data,
                title: err.message,
                show: true,
              })
          },
          forced: forced || false,
        }
        this.getMetadataSchemas(options)
      },
      viewSchema(item) {
        this.dialog = true
        this.selectedSchema = item

      },
    },
    async mounted() {
      //this.fetchMetadataSchemas({})
      this.dialog = false
      var currentTenantId = this.currentTenant.id
      var service = '9ebaa58a-1f9a-4355-91b8-b9a30862c498'
      this.isLoading = true
      const response = await this.fetchTenantConfigurations({
        service: {Id: service},
        tenantId: currentTenantId,
      })
      console.log(response)
      this.schemas = response.data
      this.isLoading = false
    },
  }
</script>

<style lang="stylus" scoped></style>